import { render, staticRenderFns } from "./MultipleContentDeleteModal.vue?vue&type=template&id=632d21bf"
import script from "./MultipleContentDeleteModal.vue?vue&type=script&lang=js"
export * from "./MultipleContentDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('632d21bf')) {
      api.createRecord('632d21bf', component.options)
    } else {
      api.reload('632d21bf', component.options)
    }
    module.hot.accept("./MultipleContentDeleteModal.vue?vue&type=template&id=632d21bf", function () {
      api.rerender('632d21bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/MultipleContentDeleteModal.vue"
export default component.exports